<template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition
        :title="page"
        :breadcrumbs="breadcrumbs"
        icon="mdi-autorenew"
    ></vuse-section-definition>
    <v-container fluid>
      <v-row class="mx-1">
        <v-col cols="12" class="content_category mb-5 pl-8 rounded-lg">
          <h3 class="mt-2 mb-10">Banner</h3>
          <v-row>
            <v-col cols="6">
              <v-row>
                <v-col cols="5">
                  <v-file-input
                      label="Ảnh desktop"
                      placeholder="Tải ảnh lên"
                      prepend-icon="mdi-camera"
                      @change="fileBannerDesktop"
                  ></v-file-input>
                  <v-img :src="src" contain aspect-ratio="1.7"></v-img>
                </v-col>
                <v-col cols="5">
                  <v-file-input
                      label="Ảnh mobile"
                      placeholder="Tải ảnh lên"
                      prepend-icon="mdi-camera"
                      @change="fileBannerMobile"
                  ></v-file-input>
                  <v-img :src="src1" contain aspect-ratio="1.7"></v-img>
                </v-col>
                <v-col class="ml-3 mt-5" cols="10">
                  <v-select
                      background-color="#EDF2F7"
                      filled
                      item-text="text"
                      v-model="banner.typeLink"
                      :items="types"
                      item-value="id"
                      label="Chọn loại Link"
                  ></v-select>
                </v-col>
                <v-col class="ml-3" cols="10" v-show="banner.typeLink == 2">
                  <v-text-field
                      background-color="#EDF2F7"
                      filled
                      v-model="banner.link.url"
                      item-text="name"
                      item-value="id"
                      label="Nhập đường dẫn"
                  ></v-text-field>
                </v-col>
                <v-col class="ml-3" cols="10" v-show="banner.typeLink == 1">
                  <v-select
                      background-color="#EDF2F7"
                      filled
                      item-text="text"
                      v-model="select_type"
                      :items="list_type"
                      item-value="id"
                      label="Chọn loại"
                  ></v-select>
                </v-col>
                <v-col class="ml-3" cols="10" v-show="banner.typeLink == 1">
                  <v-autocomplete
                      background-color="#EDF2F7"
                      filled
                      v-model="banner.link.object_id"
                      item-text="name"
                      item-value="slug"
                      :items="list_ids"
                      label="Chọn ID"
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="6">
              <ck-content class="ck-news" :content="description" @getData="value => description = value"/>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" class="mb-5">
          <v-row>
            <v-col cols="6" style="padding: 0px 10px 0px 0px ">
              <div class="rounded-lg pa-11 " style="background-color: white; height: 100%">
                <v-row>
                  <h3 class="mb-5">Trải nghiệm tính năng sản phẩm</h3>
                  <v-btn
                      class="ml-5 mb-5"
                      color="primary"
                      @click="addProduct_Feature_Experience()"
                  >
                    Thêm
                  </v-btn>
                </v-row>
                <v-row>
                  <div
                      class="content_property mt-5 d-flex"
                      style="max-width:100%;width:100%"
                      v-for="(item, index) in posts"
                      :key="index"
                  >
                    <v-col cols="10" class="content_category mb-3 rounded-lg" style="border:1px solid #ccc">
                      <v-select
                          v-model="item.id"
                          :items="news"
                          item-text="name"
                          item-value="id"
                          background-color="#EDF2F7"
                          filled
                          label="Chọn bài viết"
                          placeholder="Bài viết"
                      ></v-select>
                      <v-row>
                        <v-col cols="6">
                          <v-textarea
                              background-color="#EDF2F7"
                              filled
                              label="Mô tả"
                              v-model="item.description"
                              placeholder="Nhập mô tả ngắn"
                          >
                          </v-textarea>
                        </v-col>

                        <v-col cols="6">
                          <v-file-input
                              label="Ảnh desktop"
                              placeholder="Tải ảnh lên"
                              prepend-icon="mdi-camera"
                              @change="fileBannerPost($event, 'srcPost', 'posts', 'photo_url', index)"
                          ></v-file-input>
                          <v-img :src="srcPost[index] ? srcPost[index] : item.photo_url_path" contain aspect-ratio="1.7"></v-img>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="2" class="mt-3">
                      <div style="display: flex; justify-content: flex-end ;margin-top:-10px">
                        <v-btn color="primary" @click="clearProduct_Feature_Experience(index)">
                          Xóa
                        </v-btn>
                      </div>
                    </v-col>
                  </div>
                </v-row>
              </div>
            </v-col>
            <v-col cols="6" style="padding: 0px 0px 0px 10px ">
              <div class="rounded-lg pa-11" style="background-color: white;">
                <h3 class="mb-5">Thể lệ chương trình</h3>
                <ck-content class="ck-news" :content="content" @getData="value => content = value"/>
              </div>

            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" class="mb-5">
          <v-row>
            <v-col cols="6" style="padding: 0px 10px 0px 0px ">
              <div class="rounded-lg pa-11" style="background-color: white; height: 100%">
                <h3 class="mb-10">Thu cũ đổi Bosch</h3>
                <v-row class="pl-5">
                  <v-icon x-small>mdi-brightness-1</v-icon>
                  <h4 class="ml-3">Banner</h4>
                </v-row>
                <v-row>
                  <v-col cols="5">
                    <v-file-input
                        label="Ảnh desktop"
                        placeholder="Tải ảnh lên"
                        prepend-icon="mdi-camera"
                        @change="fileBannerDesktopBosch"
                    ></v-file-input>
                    <v-img :src="srcBosch" contain aspect-ratio="1.7"></v-img>
                  </v-col>
                  <v-col cols="5">
                    <v-file-input
                        label="Ảnh mobile"
                        placeholder="Tải ảnh lên"
                        prepend-icon="mdi-camera"
                        @change="fileBannerMobileBosch"
                    ></v-file-input>
                    <v-img :src="srcBosch1" contain aspect-ratio="1.7"></v-img>
                  </v-col>
                </v-row>
                <v-row class="pl-5">
                  <v-icon x-small>mdi-brightness-1</v-icon>
                  <h4 class="ml-3 mt-1">Category</h4>
                  <v-btn
                      class="ml-5"
                      color="primary"
                      @click="addCategory()"
                  >
                    Thêm
                  </v-btn>
                </v-row>
                <v-col cols="12">
                  <div
                      class="content_property mt-5 rounded-lg"
                      v-for="(item, index) in category.categoryIDs"
                      :key="index"
                  >
                    <v-row>
                      <v-col cols="10" style="margin-left: -20px">
                        <v-autocomplete
                            v-model="item.id"
                            background-color="#EDF2F7"
                            filled
                            item-value="id"
                            item-text="name"
                            :items="categories"
                            label="Chọn Category"
                            placeholder="Chọn Category"
                        ></v-autocomplete>
                      </v-col>
                      <v-col cols="2" class="mt-3">
                        <div style="display: flex; justify-content: flex-end">
                          <v-btn color="primary" @click="clearCategory(index)">
                            Xóa
                          </v-btn>
                        </div>
                      </v-col>
                    </v-row>

                  </div>
                </v-col>
              </div>
            </v-col>
            <v-col cols="6" style="padding: 0px 0px 0px 10px ">
              <div class="rounded-lg pa-11" style="background-color: white; height: 100%">
                <h3 class="mb-10">Đăng ký thu cũ đổi mới</h3>
                <v-row class="pl-5">
                  <v-icon x-small>mdi-brightness-1</v-icon>
                  <h4 class="ml-3">Banner</h4>
                </v-row>
                <v-row>
                  <v-col cols="5">
                    <v-file-input
                        label="Ảnh desktop"
                        placeholder="Tải ảnh lên"
                        prepend-icon="mdi-camera"
                        @change="fileBannerDesktopRenew"
                    ></v-file-input>
                    <v-img :src="srcRenew"></v-img>
                  </v-col>
                  <v-col cols="5">
                    <v-file-input
                        label="Ảnh mobile"
                        placeholder="Tải ảnh lên"
                        prepend-icon="mdi-camera"
                        @change="fileBannerMobileRenew"
                    ></v-file-input>
                    <v-img :src="srcRenew1"></v-img>
                  </v-col>

                </v-row>
              </div>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" class="text-center">
          <v-btn color="primary" width="180" @click="update()"> Lưu</v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import CkContent from "@/components/ck-content"
import { replaceCkContent } from '@/utils/helpers'
import {
  GET_LIST_CONFIG_RENEW,
  UPDATE_LIST_CONFIG_RENEW,
  UPLOAD_RENEW_IMAGE
} from "@/store/modules/configs";
import {GET_LIST_CATEGORY} from "@/store/modules/category";
import {GET_LIST_BRAND} from "@/store/modules/brand";
import {GET_LIST_TAG} from "@/store/modules/tag";
import {mapGetters} from "vuex";
import {GET_LIST_NEWS} from "@/store/modules/news";

export default {
  name: "config_renew",
  components: {CkContent},
  data() {
    return {
      page: "Thu cũ đổi mới",
      breadcrumbs: [
        {
          text: "Trang chủ",
          disabled: true,
        },
        {
          text: "Quản lý trang",
          disabled: true,
        },
        {
          text: "Thu cũ đổi mới",
          disabled: true,
        }
      ],
      /*type link*/
      types: [
        {
          id: 1,
          text: "Link theo loại",
        },
        {
          id: 2,
          text: "Link theo URL",
        },
      ],
      list_type: [
        {
          id: "category",
          text: "category",
        },
        {
          id: "brand",
          text: "brand",
        },
        {
          id: "tag",
          text: "tag",
        },
      ],
      banner: {
        src_banner_mobile: "",
        src_banner_desktop: "",
        typeLink: null,
        link: {
          type: '',
          object_id: null,
          url: null,
        },
      },
      description: '',
      content: '',
      posts: [],
      category: {
        src_banner_mobile_Bosch: "",
        src_banner_desktop_Bosch: "",
        categoryIDs: [],
      },
      register: {
        src_banner_mobile_Renew: "",
        src_banner_desktop_Renew: "",
      },
      list_ids: null,
      select_type: null,

      /*image*/
      src: "",
      src1: "",
      srcBosch: "",
      srcBosch1: "",
      srcRenew: "",
      srcRenew1: "",
      srcPost: []


    }
  },
  watch: {
    config_renew(val) {
      this.src = val.banner.photo_url_path;
      this.src1 = val.banner.photo_url_mobile_path;
      this.description = val.description;
      this.content = val.content;
      this.banner.link.url = val.banner.link.url;
      this.banner.typeLink = val.banner.type;
      this.select_type = val.banner.link.type;
      this.banner.link.object_id = val.banner.link.object_id;
      this.posts = val.posts;
      this.srcBosch = val.categories.photo_url_path;
      this.srcBosch1 = val.categories.photo_url_mobile_path;
      this.category.categoryIDs = val.categories.ids;
      this.srcRenew = val.register.photo_url_path;
      this.srcRenew1 = val.register.photo_url_mobile_path;
    },
    select_type(val) {
      this.banner.link.type = val;
      const _this = this;
      let url = "";
      if (val == "category") {
        url = GET_LIST_CATEGORY;
      }
      if (val == "brand") {
        url = GET_LIST_BRAND;
      }
      if (val == "tag") {
        url = GET_LIST_TAG;
      }
      if (url != "") {
        this.$store.dispatch(url).then((data) => {
          if (data && data.data && data.data.length > 0) {
            _this.list_ids = data.data;
          } else {
            _this.list_ids = [];
          }
        });
      }
    },
  },
  computed: {
    ...mapGetters({
      categories: "categories",
      news: "news",
      config_renew: "config_renew",
    }),
  },
  async created() {
    await this.$store.dispatch(`${GET_LIST_CATEGORY}`, {brand_id: 2});
    await this.$store.dispatch(`${GET_LIST_NEWS}`);
    await this.$store.dispatch(`${GET_LIST_CONFIG_RENEW}`);
  },
  methods: {
    async update() {
      if (this.banner.typeLink == 1) {
        this.banner.link = {
          type: this.banner.link.type,
          object_id: this.banner.link.object_id,
          url: null
        }
      }
      if (this.banner.typeLink == 2) {
        this.banner.link = {
          type: null,
          object_id: null,
          url: this.banner.link.url,
        }
      }
      let data_banner = {
        photo_url: this.banner.src_banner_desktop ? this.banner.src_banner_desktop : this.config_renew.banner.photo_url_path,
        photo_url_mobile: this.banner.src_banner_mobile ? this.banner.src_banner_mobile : this.config_renew.banner.photo_url_mobile_path,
        type: this.banner.typeLink,
        link: this.banner.link,
      }
      let data_category = {
        photo_url: this.category.src_banner_desktop_Bosch ? this.category.src_banner_desktop_Bosch : this.config_renew.categories.photo_url_path,
        photo_url_mobile: this.category.src_banner_mobile_Bosch ? this.category.src_banner_mobile_Bosch : this.config_renew.categories.photo_url_mobile_path,
        ids: this.category.categoryIDs
      }

      let data_register = {
        photo_url: this.register.src_banner_desktop_Renew ? this.register.src_banner_desktop_Renew : this.config_renew.register.photo_url_path,
        photo_url_mobile: this.register.src_banner_mobile_Renew ? this.register.src_banner_mobile_Renew : this.config_renew.register.photo_url_mobile_path,
      }

      let data = {
        banner: data_banner,
        description: replaceCkContent(this.description),
        content: replaceCkContent(this.content),
        posts: this.posts,
        categories: data_category,
        register: data_register
      }

      await this.$store.dispatch(`${UPDATE_LIST_CONFIG_RENEW}`, data).then((data) => {
        if (data.status === 1) {
          this.$toasted.success('Cập nhật thành công!', {
            duration: 1000,
            position: 'top-center'
          })
          this.$store.dispatch(`${GET_LIST_CONFIG_RENEW}`);
        } else {
          alert(data.errors);
        }
      });
    },
    addProduct_Feature_Experience() {
      this.posts.push({
        id: null,
      });
    },
    clearProduct_Feature_Experience(i) {
      this.posts.splice(i, 1);
      this.$forceUpdate();
    },
    addCategory() {
      this.category.categoryIDs.push({
        id: null,
      });
    },
    clearCategory(i) {
      this.category.categoryIDs.splice(i, 1);
      this.$forceUpdate();
    },

    fileBannerDesktop(event) {
      const _this = this;
      if (!event) {
        this.src = '';
        this.banner.src_banner_desktop = "";
      }
      this.src = URL.createObjectURL(event);
      let formData = new FormData();
      formData.append("upload", event);
      formData.append("type", "banners");
      this.$store.dispatch(`${UPLOAD_RENEW_IMAGE}`, formData).then((data) => {
        if (data && data.data && data.data.data) {
          data.data.data.forEach(element => {
            _this.banner.src_banner_desktop = element.path;
          })
        }
      })
    },
    fileBannerMobile(event) {
      const _this = this;
      if (!event) {
        this.src1 = '';
        this.banner.src_banner_mobile = "";
      }
      this.src1 = URL.createObjectURL(event);
      let formData = new FormData();
      formData.append("upload", event);
      formData.append("type", "banners");
      this.$store.dispatch(`${UPLOAD_RENEW_IMAGE}`, formData).then((data) => {
        if (data && data.data && data.data.data) {
          data.data.data.forEach(element => {
            _this.banner.src_banner_mobile = element.path;
          })
        }
      })
    },
    fileBannerDesktopBosch(event) {
      const _this = this;
      if (!event) {
        this.srcBosch = '';
        this.category.src_banner_desktop_Bosch = "";
      }
      this.srcBosch = URL.createObjectURL(event);
      let formData = new FormData();
      formData.append("upload", event);
      formData.append("type", "banners");
      this.$store.dispatch(`${UPLOAD_RENEW_IMAGE}`, formData).then((data) => {
        if (data && data.data && data.data.data) {
          data.data.data.forEach(element => {
            _this.category.src_banner_desktop_Bosch = element.path;
          })
        }
      })
    },
    fileBannerMobileBosch(event) {
      const _this = this;
      if (!event) {
        this.srcBosch1 = '';
        this.category.src_banner_mobile_Bosch = "";
      }
      this.srcBosch1 = URL.createObjectURL(event);
      let formData = new FormData();
      formData.append("upload", event);
      formData.append("type", "banners");
      this.$store.dispatch(`${UPLOAD_RENEW_IMAGE}`, formData).then((data) => {
        if (data && data.data && data.data.data) {
          data.data.data.forEach(element => {
            _this.category.src_banner_mobile_Bosch = element.path;
          })
        }
      })
    },
    fileBannerDesktopRenew(event) {
      const _this = this;
      if (!event) {
        this.srcRenew = '';
        this.register.src_banner_desktop_Renew = "";
      }
      this.srcRenew = URL.createObjectURL(event);
      let formData = new FormData();
      formData.append("upload", event);
      formData.append("type", "banners");
      this.$store.dispatch(`${UPLOAD_RENEW_IMAGE}`, formData).then((data) => {
        if (data && data.data && data.data.data) {
          data.data.data.forEach(element => {
            _this.register.src_banner_desktop_Renew = element.path;
          })
        }
      })
    },
    fileBannerMobileRenew(event) {
      const _this = this;
      if (!event) {
        this.srcRenew1 = '';
        this.register.src_banner_mobile_Renew = "";
      }
      this.srcRenew1 = URL.createObjectURL(event);
      let formData = new FormData();
      formData.append("upload", event);
      formData.append("type", "banners");
      this.$store.dispatch(`${UPLOAD_RENEW_IMAGE}`, formData).then((data) => {
        if (data && data.data && data.data.data) {
          data.data.data.forEach(element => {
            _this.register.src_banner_mobile_Renew = element.path;
          })
        }
      })
    },
    fileBannerPost(event, src = 'src', type = 'posts', type_element = 'photo_url', index = '') {
      const _this = this;
      if (!event) {
        this[src][index] = '';
        this[type][index][type_element] = "";
      }
      this[src][index] = URL.createObjectURL(event);
      let formData = new FormData();
      formData.append("upload", event);
      formData.append("type", "banners");
      this.$store.dispatch(`${UPLOAD_RENEW_IMAGE}`, formData).then((data) => {
        if (data && data.data && data.data.data) {
          data.data.data.forEach(element => {
            console.log(type, index, type_element, element.path);
            _this[type][index][type_element] = element.path;
            this.$forceUpdate()
          })
        }
      })
    },
  }
}
</script>

<style scoped lang="scss">
.content_category {
  background-color: white !important;
  .content-textarea .v-input__control {
    height: 165px !important;
  }
}

</style>